<div class="modal-dialog modal-lg" style="margin-top: 0px; margin-bottom: 0px">
  <div class="modal-content">
    <div class="modal-header">
      <aurora-icon-button class="close" type="button" (click)="cancel()" icon="times" size="large"></aurora-icon-button>
      <h4 class="modal-title">
        {{ title }}
      </h4>
    </div>

    <div class="modal-body">
      <ep-panel panelType="transparent" *ngIf="articles">
        <ep-row>
          <div class="col-12" style="display: inline-block; max-width: 100%; margin-bottom: 10px; font-size: 1.7em">
            {{ message }}
          </div>
        </ep-row>
        <ep-row>
          <div
            class="col-12"
            *ngFor="let article of articles"
            style="display: inline-block; max-width: 100%; margin-bottom: 5px; font-size: 1.6em; margin-left: 2em"
          >
            {{ article.Article_Desc }}
          </div>
        </ep-row>
        <ep-row>
          <div
            class="col-12"
            style="
              display: inline-block;
              max-width: 100%;
              margin-top: 10px;
              margin-bottom: 5px;
              font-size: 1.7em;
              font-weight: 600;
            "
          >
            Would you like to proceed with deleting the location?
          </div>
        </ep-row>
      </ep-panel>
    </div>
    <div class="modal-footer">
      <aurora-button type="button" (click)="confirm()" variant="primary">Confirm</aurora-button>
      <aurora-button type="button" (click)="cancel()" variant="ghost">Cancel</aurora-button>
    </div>
  </div>
</div>
